import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslocoService } from '@ngneat/transloco';
import { SearchResourcesDialogComponent } from '../search-resources-dialog/search-resources-dialog.component';
import { DialogsService } from '../dialogs.service';
import { AbstractControl, FormControl, ValidatorFn, Validators } from '@angular/forms';
import { ServicesService } from '../../modules/admin/services/services.service';
import { FuseConfirmationService } from '../../../@fuse/services/confirmation/confirmation.service';
import { LocalizePipe } from '../../core/pipes/localize.pipe';

@Component({
    selector: 'app-change-repo-name',
    templateUrl: './change-repo-name.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ChangeRepoNameComponent implements OnInit {

    regexp: RegExp = new RegExp('^[a-zA-Z][a-zA-Z0-9]+$');
    nameControl: FormControl;
    errorLength = false;
    patternError = false;
    equalError = false;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: string,
        private dialogsService: DialogsService,
        public dialogRef: MatDialogRef<SearchResourcesDialogComponent>,
        private servicesService: ServicesService,
        private _fuseConfirmationService: FuseConfirmationService,
        private transloco: TranslocoService,
        private localize: LocalizePipe
    ) { }

    /**
     * On init
     */
    async ngOnInit() {
        this.nameControl = new FormControl('', Validators.required);
        this.nameControl.valueChanges.subscribe((value) => {
            if (value.length === 0 || value.length > 20) {
                this.nameControl.setErrors({ 'incorrect': true });
                this.errorLength = true;
            } else {
                this.errorLength = false;
            }
            if (!this.regexp.test(value)) {
                this.nameControl.setErrors({ 'incorrect': true });
                this.patternError = true;
            } else {
                this.patternError = false;
            }
            if (this.data === value) {
                this.nameControl.setErrors({ 'incorrect': true });
                this.equalError = true;
            } else {
                this.equalError = false;
            }
        });
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    async saveName(action: string) {
        if (action === 'save') {
            if (this.nameControl.valid) {
                const confirmSave = await this.confirm(this.transloco.translate('warning'), this.transloco.translate('services.dialog.changeRepoName.saveName'));
                if (confirmSave) {
                    this.dialogRef.close(this.nameControl.value);
                }
            }
        } else if (action === 'cancel') {
            this.dialogRef.close();
        }
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Private methods
    // -----------------------------------------------------------------------------------------------------

    private confirm(title?: string, message?: string, confirm?: string, cancel?: string) {
        const dialogRef = this._fuseConfirmationService.open({
            title: title ? title : this.transloco.translate('unsavedChanges'),
            message: message ? message : this.transloco.translate('exitWithUnsavedChanges'),
            actions: {
                confirm: {
                    label: confirm ? confirm : this.transloco.translate('accept')
                },
                cancel: {
                    label: cancel ? cancel : this.transloco.translate('cancel')
                }
            }
        });

        return new Promise<boolean>((resolve) => {
            dialogRef.afterClosed().subscribe((result) => {
                if (result === 'confirmed') {
                    resolve(true);
                } else {
                    resolve(false);
                }
            });
        });
    }
}
